import { Tag } from "@octopusdeploy/design-system-components";
import type { ArgoCDApplicationSourceResource } from "@octopusdeploy/octopus-server-client";
type SourceTypeTagProps = {
    source: ArgoCDApplicationSourceResource;
};
export const SourceTypeTag = (props: SourceTypeTagProps) => {
    const { source } = props;
    if (source.SourceType === null) {
        return <Tag label={"Unknown"}/>;
    }
    else {
        return <Tag label={source.SourceType}/>;
    }
};
